<script setup>
import { computed, inject, ref } from "vue";
import { formatDate } from "../lib/es-bill-shared-js/misc/timeTools";
import edaTools from "@/lib/es-bill-shared-js/misc/edaTools";
import { getMaintainersForCommunity } from "@/services/accountService";
import { useCommunitiesStore } from "@/stores/communitiesStore";
import { PrimaryButton } from '@es-bill/es-bill-common-components';

const $log = inject('log');
const communitiesStore = useCommunitiesStore();

const communitiesNotDemoNorEP = computed(() => {
  return communitiesStore.allCommunities.filter(c =>
    edaTools.isEcnValidExternal(c.ecn) && !c.ecn.startsWith("EP")
  )
})

const accountCommunities = ref(null);
accountCommunities.value = {};

const allAddressCombinded = computed(() => {
  return allAddresses.value.join("; ");
})

const allAddresses = computed(() => {
  let accounts = [];

  for(const [key, value] of Object.entries(accountCommunities.value)){

    for(const user of value)
      if(user.enabled && user.stillRelevant && accounts.includes(user.username) === false)
        accounts.push(user.username);

  }

  return accounts
})

const communitiesReport = computed(() => {
  let cr = [];

  for(const c of communitiesNotDemoNorEP.value) {
    // $log.warn(c.name);

    cr.push({
      ...c,
      maintainers: accountCommunities.value[c.ecn] || [],
    });
  }

  return cr;
});



async function fetchAccounts() {
  const today = new Date();

  for (const c of communitiesReport.value) {
    // $log.warn("fetchAccounts",c.name,c.ecn);

    accountCommunities.value[c.ecn] = (await getMaintainersForCommunity(c)).map(a => {
      return {
        ...a,
        stillRelevant: !(c.dateEnd&&c.dateEnd<today),
      }
    })
  }

}



</script>

<script>
export default {
  name: 'ViewAllMaintainers',
}
</script>


<template>
  <v-container class="containerBase pa-0">

    <v-container class="containerStandard">

      <p class="textHeadline">{{ $t('maintainer-overview') }}</p>
      Liste der aktiven Verwalter<br>
      <br>
      Aktive Verwalter sind Verwaltungsaccounts von Gemeinschaften, die nicht per
      community.dateStart oder community.dateEnd (Zu- und Abwanderung von anderen Dienstleistern) ausgeschlossen sind.<br>
      <br>

      <PrimaryButton @click="fetchAccounts" :text="$t ? $t('fetchMaintainers') : 'Abfrage Verwalter'" /><br><br>

      <u>Akitve Accounts von noch aktiven Gemeinschaften (für BCC, Anzahl: {{ allAddresses.length }}): </u><br>
      {{ allAddressCombinded }}<br><br>

      <u>Technische Gemeinschaftsliste:</u>
      <div v-for="community in communitiesReport" :key="community.ecn">
        <u>{{community.ecn}}: {{community.name}}<br></u>
        ECID: {{community.ecid}}<br>
        Start/Onboarding: {{ formatDate(community.dateStart) }}<br>
        Offboarding: {{ formatDate(community.dateEnd) }}<br>
        Verwalter: <br>
        <ul>
          <li v-for="(account, index) in community.maintainers" :key="index">
            {{ account.username }}
            {{ account.enabled?"":"(gesperrt)" }}
            {{ account.stillRelevant?"":"(nicht mehr relevant)" }}
            {{ account.requiredActions.includes("UPDATE_PASSWORD")?"Passwort-Reset offen":"" }}
            {{ account.emailVerified?"":"E-Mail nicht verifiziert" }}



          </li>
        </ul>
        <br>
      </div>

    </v-container>
  </v-container>
</template>

<style scoped>

</style>
